import React from "react";
import { Redirect, withRouter } from "react-router-dom";

const MaybeRedirectToOrigin = withRouter(
  ({ location, destination, push = true }) => {
    const { state } = location;
    if (!state) return <Redirect to={destination || location.pathname} />;

    return <Redirect to={state.from} push={push} />;
  }
);

export default MaybeRedirectToOrigin;



// WEBPACK FOOTER //
// ./src/Routing/MaybeRedirectToOrigin.js